import React from 'react';
import Truncate from 'react-truncate';

import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

// Searchkit
import {
  SearchBar,
  SearchFacetMenuSelect,
  SearchFacetRefinementCheckboxes,
  SearchFacets,
  SearchResults,
  SearchSortBy,
  SearchStats,
  SearchkitWrapper,
  SearchPagination,
} from '@uncinc/react-searchkit';

import { APP_OPTIONS, SEARCHKIT_HOST_URL } from '../../config/constants';

import './style.scss';

const Item = ({ hit }) => (
  <article className="Search__item">
    <strong>
      {hit.type}
    </strong>
    <div>
      {hit.created}
    </div>

    <h3 className="asH4">{hit.page_title[0]}</h3>

    <Truncate>
      <WysiwygField
        html={hit.body_summarized}
      />
    </Truncate>
  </article>
);

const App = () => {
  return (
    <Container className="Search">
      <SearchkitWrapper
        connection={{
          host: SEARCHKIT_HOST_URL,
        }}
        indexName={APP_OPTIONS.parameters.searchkitIndexAllContent}
        routing
        searchSettings={{
          search_attributes: ['page_title', 'body_summarized'],
          result_attributes: ['type', 'created', 'page_title', 'body_summarized'],
          facet_attributes: [
            {
              attribute: 'type',
              field: 'type.keyword',
              type: 'string',
            },
            {
              attribute: 'page_title',
              field: 'page_title.keyword',
              type: 'string',
            },
            {
              attribute: 'created',
              field: 'created',
              type: 'numeric',
            },
          ],
          sorting: {
            default: {
              field: '_score',
              order: 'desc',
            },
            page_title_asc: {
              field: 'page_title',
              order: 'asc',
            },
            page_title_desc: {
              field: 'page_title',
              order: 'desc',
            },
          },
        }}
      >
        <div className="row">
          <div className="col-12">
            <SearchBar placeholder="Zoek door artikelen..." />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-4">
            <SearchFacets>
              <SearchFacetMenuSelect attribute="page_title" />
              <SearchFacetRefinementCheckboxes attribute="type" />
              {/* @TODO: Add date range facet */}
            </SearchFacets>
          </div>
          <div className="col-12 col-md-8">
            <div className="header">
              <SearchStats />
              <SearchSortBy
                items={[
                  { label: 'Titel (A - Z)', value: 'page_title_asc' },
                  { label: 'Titel (Z - A)', value: 'page_title_desc' },
                ]}
              />
            </div>
            <SearchResults renderItem={(hit) => <Item hit={hit} />} />
            <SearchPagination />
          </div>
        </div>
      </SearchkitWrapper>
    </Container>
  );
};

export default App;
